import { Expose } from "@nts/std/serialization";
import { NumberDecorator } from '../decorators/number.decorator';
import { OCCAuditDeactivableModel } from '../occ-audit-deactivable-model';
import type { CompanySingleAggregateIdentityInterface } from '@nts/std/interfaces';


export class CompanySingleAggregateAuditDeactivableModel<TCompanySingleAggregateIdentity extends CompanySingleAggregateIdentityInterface>
  extends OCCAuditDeactivableModel<TCompanySingleAggregateIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...OCCAuditDeactivableModel.PROPERTY_LIST,
    'companyId'
  ];

  private _companyId: number = 0;

  @Expose()
  @NumberDecorator({ displayNameKey: 'CompanySingleAggregateModel_CompanyId' })
  get companyId(): number {
    return this.getValueForIdentityValue<number>(() => this._companyId, 'companyId');
  }
  set companyId(value: number) {
    this.setValueForIdentityValue<number>(() => { this._companyId = value; }, value, 'companyId');
  }
}
